
<template>
    <div id="login" class="login-container">
        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
            <div class="title-container">
                <h2 class="title"><el-image
                class="icon" :src="iconUrl"></el-image>夕乐苑智慧机构养老综合管理系统</h2>
            </div>
            <el-card class="box-card" :body-style='cardStyle'>
                <el-row>
                    <el-col :span="14" style="padding-right:10px">
                        <el-image style="width: 303px;height: 280px;margin-left: 33px;" :src="url"></el-image>
                    </el-col>
                    <el-col :span="10"  style="padding-left:10px">
                        <div>
                            <p style="font-size:20px">欢迎登录</p >
                        </div>
                        <el-form-item prop="username">
                            <el-input placeholder="输入登录账号" ref="username" v-model="loginForm.username" name="username"
                                type="text" autocomplete='on'>
                                <i slot="prefix" class="el-input__icon el-icon-user"></i>
                            </el-input>
                        </el-form-item>
                        <el-form-item prop="password">
                            <el-input placeholder="输入登录账号" ref="username" v-model="loginForm.password" name="password"
                                type="text"
                                autocomplete='on'
                                show-password
                                @keyup.enter.native="handleLogin">
                                <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                            </el-input>
                        </el-form-item>
                        <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click.native.prevent="handleLogin">登录</el-button>
                    </el-col>
                </el-row>
            </el-card>
        </el-form>
        <div class='foot'>
            <p>技术支持：安徽乐庭健康养老产业有限责任公司</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            return {
                loginForm: {
                    username: '',
                    password: '',
                    redirect:undefined
                },
                loginRules: {
                },
                url:require('@/assets/leftlogin.jpg'),
                iconUrl:require('./img/logo.png'),
                loading: false,
                passwordType: 'password',
                cardStyle:'{border-radius:10px;padding: 30px;}'
            }
        },
        watch: {
            $route: {
                handler: function(route) {
                    this.loginForm.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        //创建前设置
        beforeCreate () {
            document.querySelector('body').setAttribute('style', 'height:100vh;')
        },
        //销毁前清除
        beforeDestroy () {
            document.querySelector('body').removeAttribute('style')
        },
        methods: {
            showPwd() {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }
                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            },
            handleLogin() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        this.loading = true
                        this.$emit('handleLogin',this.loginForm)
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            }
        }
    }

</script>

<style lang="scss" scoped>
    $bg:#2d3a4b;
    $dark_gray:#889aa4;
    $light_gray:#eee;

    .login-container {
        min-height: 100%;
        width: 100%;
        background-color: $bg;
        background-image: url(../../assets/loginBackground.jpg);
        background-size: cover;
        -webkit-background-size: cover;
        -o-background-size: cover;
        background-position: center 0;
        // overflow: hidden;
        .foot{
            position: fixed;
            color: white;
            text-align: center;
            width: 100%;
            top: 90vh;
        }
        .icon{
            height: 70px;
            width: 81px;
            margin-right: 10px;
            transform: translate(0px, 16px);
        }
        .el-card{
            border-radius:10px;
        }
        .login-form {
            position: relative;
            width:750px;
            max-width: 100%;
            padding: 20vh 35px 0;
            margin: 0 auto;
            overflow: hidden;
        }

        .tips {
            font-size: 14px;
            color: #fff;
            margin-bottom: 10px;

            span {
                &:first-of-type {
                    margin-right: 16px;
                }
            }
        }

        .svg-container {
            padding: 6px 5px 6px 15px;
            color: $dark_gray;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
        }

        .title-container {
            position: relative;

            .title {
                font-size: 33px;
                color: $light_gray;
                margin: 0px auto 40px auto;
                text-align: center;
                font-weight: bold;
            }
        }

        // .show-pwd {
        //     position: absolute;
        //     right: 10px;
        //     top: 7px;
        //     font-size: 16px;
        //     color: $dark_gray;
        //     cursor: pointer;
        //     user-select: none;
        // }

        .thirdparty-button {
            position: absolute;
            right: 0;
            bottom: 6px;
        }

        @media only screen and (max-width: 470px) {
            .thirdparty-button {
                display: none;
            }
        }
    }
</style>
